import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment/moment';
import { FormControl, FormGroup } from '@angular/forms';
import { SatisfactionService } from 'src/app/services/satisfaction-services/satisfaction-service/satisfaction.service';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { Json2csvService } from 'csvtools-lib';

@Component({
  selector: 'app-satisfaction-filter-satisfactions-card',
  templateUrl: './satisfaction-filter-satisfactions-card.component.html',
  styleUrls: ['./satisfaction-filter-satisfactions-card.component.scss']
})
export class SatisfactionFilterSatisfactionsCardComponent implements OnInit {

  @Input() data;
  show: boolean;
  refreshing: boolean;
  filterSatisfactionsForm = new FormGroup({
    dateFrom: new FormControl(),
    dateTo: new FormControl(),
    timeFrom: new FormControl(),
    timeTo: new FormControl()
  });

  constructor(private satisfactionService: SatisfactionService,
              private dateUnixTrannsformerPipe: DateUnixTransformerPipe,
              private json2csvService: Json2csvService) { }

  ngOnInit() { }

  public showFilter() {
    this.show = !this.show;
  }

  public search() {
    const dateFrom = this.filterSatisfactionsForm.get('dateFrom').value ? this.filterSatisfactionsForm.get('dateFrom').value.valueOf() : null;
    const dateTo = this.filterSatisfactionsForm.get('dateTo').value ? this.filterSatisfactionsForm.get('dateTo').value.valueOf() : null;
    const timeFrom = (moment(this.filterSatisfactionsForm.get('timeFrom').value, 'hh:mm').hour() * 3600000) + (moment(this.filterSatisfactionsForm.get('timeFrom').value, 'hh:mm').minutes() * 60000);
    const timeTo = (moment(this.filterSatisfactionsForm.get('timeTo').value, 'hh:mm').hour() * 3600000) + (moment(this.filterSatisfactionsForm.get('timeTo').value, 'hh:mm').minutes() * 60000);
    const from = timeFrom ? dateFrom + timeFrom : dateFrom;
    const to = timeTo ? dateTo + timeTo : dateTo + (23 * 3600000) + (59 * 60000) + (59 * 1000);
    this.satisfactionService.refreshSatisfactions(from , to);
    this.showFilter();
  }

  public clearField(fieldName) {
    this.filterSatisfactionsForm.patchValue({
      [fieldName]: null
    });
  }

  public generateCSV() {
    this.data.forEach(i => i['satisfactionDate'] = this.dateUnixTrannsformerPipe.transform(i['satisfactionDate']));
    this.json2csvService.setBody(this.data, ['satisfactionDate', 'centerName', 'deviceName', 'applicationName', 'points']);
    this.json2csvService.setHeader(['Created', 'Center', 'Device', 'Application', 'Rating']);
    this.json2csvService.generateCSV('ratings');
  }
}
